export default "__VITE_ASSET__DYmKLdE6__"